<script setup>
import {getCurrentInstance, reactive} from "vue";
import {useSessionStorage} from "@vueuse/core";
import helpers from "@/lib/helpers";

const props = defineProps({
  auction: [String, Number],
  noQty: Boolean,
  unit: [String, Number],
  qty: [String, Number]
})

const instance = getCurrentInstance()

const edit = reactive({
  unit: props.unit,
  auction: props.auction,
  qty: props.qty
})

const order = useSessionStorage('auction_add_order', null)

const add = () => {
  if (!order.value) {
    helpers.alert("Order is required")
    return
  }
  helpers.asyncAction("/api/order/" + order.value + "/item", 'POST', {
    data: edit
  }).then(() => {
    helpers.toast('Product added to order')
    instance.proxy.$root.$emit('submit', true)
  }).catch(() => {
    instance.proxy.$root.$emit('submit')
  })
}
</script>

<template>
  <modal title="Add To Order" height="400px" no-scroll ref="modal">
    <template #footer>
      <b-button size="sm" variant="primary" @click="add">Add To Order</b-button>
    </template>

    <modal-row label="Order">
      <form-select-remote-search v-model="order" key-text="description" key-value="id"
                                 url="/api/order?filter=inquiry.open"
                                 search-url="/api/order?q="/>
    </modal-row>
    <modal-row label="Price">
      <b-input-group prepend="$" size="sm">
        <form-currency size="sm" v-model="edit.unit"/>
      </b-input-group>
    </modal-row>
    <modal-row label="Quantity" v-if="!noQty">
      <b-form-input type="number" v-model="edit.qty"/>
    </modal-row>
  </modal>
</template>

<style scoped>

</style>